$(function() {
  // Remove flash messages after certain time
  if ($('.flash-container .alert').length) {
    setTimeout(function() {
      $('.flash-container').remove();
    },2500);
  }
});
